module.exports = __webpack_public_path__ + "static/Shipra-Gupta-cb918227de9abde1525a3340e4f23098.png";